export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"}],"link":[{"rel":"icon","type":"image/x-icon","href":"/favicon.png"},{"key":"fa","rel":"stylesheet","href":"https://kit.fontawesome.com/b388635a34.css","type":"text/css","crossorigin":"anonymous"}],"style":[{"type":"text/css","innerHTML":"\n\n.zazos-theme {\n  --z-theme-black: #333333;--z-theme-black-rgb: 51,51,51;--z-theme-white: #fafafa;--z-theme-white-rgb: 250,250,250;--z-theme-primary: #3F51B5;--z-theme-primary-rgb: 63,81,181;--z-theme-secondary: #3F51B5;--z-theme-secondary-rgb: 63,81,181;\n}\n\n\n.zazos-theme--light {\n  color-scheme: light;\n  --z-theme-primary: #3F51B5;--z-theme-primary-rgb: 63,81,181;--z-theme-secondary: #3F51B5;--z-theme-secondary-rgb: 63,81,181;--z-theme-background: #fafafa;--z-theme-background-rgb: 250,250,250;--z-theme-text: #333333;--z-theme-text-rgb: 51,51,51;--z-theme-shadow: #00000033;--z-theme-shadow-rgb: 0,0,0,02;--z-theme-error: #b00020;--z-theme-error-rgb: 176,0,32;--z-theme-warning: #ffab00;--z-theme-warning-rgb: 255,171,0;--z-theme-info: #2196f3;--z-theme-info-rgb: 33,150,243;--z-theme-success: #4caf50;--z-theme-success-rgb: 76,175,80;--z-theme-background-secondary: #f1f1f1;--z-theme-background-secondary-rgb: 241,241,241;--z-theme-surface: #ffffff;--z-theme-surface-rgb: 255,255,255;--z-theme-surface-highlight: #f6f6f6;--z-theme-surface-highlight-rgb: 246,246,246;--z-theme-text-secondary: #3f3f3f;--z-theme-text-secondary-rgb: 63,63,63;--z-theme-text-tertiary: #494949;--z-theme-text-tertiary-rgb: 73,73,73;--z-theme-border: #d9d9d9;--z-theme-border-rgb: 217,217,217;--z-theme-border-neutral: #e9e9e9;--z-theme-border-neutral-rgb: 233,233,233;--z-theme-border-highlight: #afafaf;--z-theme-border-highlight-rgb: 175,175,175;\n}\n\n\n.zazos-theme--dark {\n  color-scheme: dark;\n  --z-theme-primary: #3F51B5;--z-theme-primary-rgb: 63,81,181;--z-theme-secondary: #3F51B5;--z-theme-secondary-rgb: 63,81,181;--z-theme-background: #303030;--z-theme-background-rgb: 48,48,48;--z-theme-text: #fafafa;--z-theme-text-rgb: 250,250,250;--z-theme-shadow: #00000033;--z-theme-shadow-rgb: 0,0,0,02;--z-theme-error: #b00020;--z-theme-error-rgb: 176,0,32;--z-theme-warning: #ffab00;--z-theme-warning-rgb: 255,171,0;--z-theme-info: #2196f3;--z-theme-info-rgb: 33,150,243;--z-theme-success: #4caf50;--z-theme-success-rgb: 76,175,80;--z-theme-background-secondary: #454545;--z-theme-background-secondary-rgb: 69,69,69;--z-theme-surface: #282828;--z-theme-surface-rgb: 40,40,40;--z-theme-surface-highlight: #242424;--z-theme-surface-highlight-rgb: 36,36,36;--z-theme-text-secondary: #cacaca;--z-theme-text-secondary-rgb: 202,202,202;--z-theme-text-tertiary: #afafaf;--z-theme-text-tertiary-rgb: 175,175,175;--z-theme-border: #626262;--z-theme-border-rgb: 98,98,98;--z-theme-border-neutral: #4c4c4c;--z-theme-border-neutral-rgb: 76,76,76;--z-theme-border-highlight: #8c8c8c;--z-theme-border-highlight-rgb: 140,140,140;\n}\n\n"}],"script":[{"type":"text/javascript","innerHTML":"// Upsert utm params on local storage if they exist\nlet utmParams = {};\n\ntry {\n  utmParams = JSON.parse(localStorage.getItem('utm')) || {};\n} catch {\n  // Do nothing\n}\n\nconst urlParams = new URLSearchParams(window.location.search);\n\nurlParams.forEach((value, key) => {\n  if (key.startsWith('utm_')) {\n    utmParams[key] = value;\n  }\n});\n\nlocalStorage.setItem('utm', JSON.stringify(utmParams));\n"}],"noscript":[],"titleTemplate":"%s ⚡️Zazos","title":"Superpoderes para o seu RH!","htmlAttrs":{"lang":"pt-BR"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true